import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const RETRY_SUBMISSION = "RETRY_SUBMISSION";

export const service = async (data) => {
  const options = {
    url: `/api/EsMd/RetrySubmission`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => Promise.resolve(mockData());

register(RETRY_SUBMISSION, service, mock);
